import apiHelper from '@/services/helper'
const editOrderLog = async (param) => {
    try {
        let url = '/admin/order/get-updated-log'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const OrderSearchShopId = async (param, cancelToken = null) => {
    try {
        let url = '/admin/order/search'
        return (await apiHelper.postWithFirebaseToken(url, param, true, cancelToken)).data
    } catch (error) {
        throw new Error(error)
    }
}

const OrderManageExport = async (param) => {
    try {
        let url = '/admin/order/export-order-manage'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchMobileShop = async (param, cancelToken = null) => {
    try {
        let url = '/admin/order/search-mobile-shop'
        return (await apiHelper.postWithFirebaseToken(url, param, true, cancelToken)).data
    } catch (error) {
        throw new Error(error)
    }
}
const searchMobileAllOrder = async (param, cancelToken = null) => {
    try {
        let url = '/admin/order/search-mobile'
        return (await apiHelper.postWithFirebaseToken(url, param, true, cancelToken)).data
    } catch (error) {
        throw new Error(error)
    }
}
const updateAddressOrderMobile = async (param) => {
    try {
        let url = '/admin/order/update-mobile'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const logUpdateAddressOrderMobile = async (param) => {
    try {
        let url = '/admin/logging/set-valid-address'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const setLogFinance = async (param) => {
    try {
        let url = '/admin/logging/finance/set'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getLogEditUser = async (param) => {
    try {
        let url = '/admin/logging/finance/get/user'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getLogEditShop = async (param) => {
    try {
        let url = '/admin/logging/finance/get/shop'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOperationCancelTag = async (param) => {
    try {
        let url = '/admin/logging/get-cancel-tag'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getOperationCancelTagTimeStamp = async (param) => {
    try {
        let url = '/admin/logging/get-cancel-online-operation'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getInvalidShopData = async (param) => {
    try {
        let url = '/admin/logging/get-invalid-shop-data'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const setInvalidShopData = async (param) => {
    try {
        let url = '/admin/logging/set-invalid-shop-data'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const exportDetail = async (param) => {
    try {
        let url = '/admin/order/export-detail'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const exportOrderBest = async (param) => {
    try {
        let url = '/admin/order/export-order-best'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getEditorMobileLog = async (param) => {
    try {
        let url = '/admin/order/get-editor-mobile-log'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getLogSubscription = async (param) => {
    try {
        let url = `/admin/subscription/users/${param.user_id}/logging`
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}
export default {
    editOrderLog,
    OrderSearchShopId,
    searchMobileShop,
    searchMobileAllOrder,
    updateAddressOrderMobile,
    logUpdateAddressOrderMobile,
    setLogFinance,
    getLogEditUser,
    getLogEditShop,
    getOperationCancelTag,
    getOperationCancelTagTimeStamp,
    getInvalidShopData,
    setInvalidShopData,
    OrderManageExport,
    exportDetail,
    exportOrderBest,
    getEditorMobileLog,
    getLogSubscription
}
